module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921012334_T.a125eab7.jpg";